import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import IntroBlob from "./BgAnimations/IntroBlob";

gsap.registerPlugin(ScrollTrigger);

const words = [
  "Imagination",
  "Online Store",
  "Banking",
  "Government",
  "Logistics",
  "Real Estate",
];

const Intro = () => {
  const wordRef = useRef();
  const sectionRef = useRef();

  useEffect(() => {
    // Word cycling animation
    const tl = gsap.timeline({ repeat: -1 });
    words.forEach((word) => {
      tl.to(wordRef.current, {
        opacity: 0,
        duration: 0.2,
        onComplete: () => {
          wordRef.current.innerText = word;
        },
      });
      tl.to(wordRef.current, { opacity: 1, duration: 0.5 });
      tl.to(wordRef.current, { delay: 0.4 });
    });

    // Scroll-triggered parallax
    gsap.to(".intro-blob", {
      y: -100,
      ease: "none",
      scrollTrigger: {
        trigger: sectionRef.current,
        start: "top top",
        end: "bottom top",
        scrub: true,
      },
    });
  }, []);

  return (
    <section className="section intro-section" ref={sectionRef}>
      {/* Background Animation */}
      <div className="intro-background">
        <IntroBlob />
      </div>

      {/* Content Layer */}
      <div className="intro-content">
        <div className="intro-text">
          <h1 className="intro-line">Power Your</h1>
          <h1 className="intro-line">
            <div className="word-container">
              <span className="changing-text" ref={wordRef}>
                imagination
              </span>
            </div>
          </h1>
          <h1 className="intro-line">using Data & AI</h1>
        </div>
      </div>
    </section>
  );
};

export default Intro;
